export default __webpack_public_path__ + "static/media/jcb.9bfe77df.svg";